import React from "react";
import Sortable from "react-sortablejs";
import classnames from "classnames";

export const SortableList = ({ children, ...resetProps }) => (
  <Sortable className="sortable-list" {...resetProps}>
    {React.Children.map(children, child => {
      if (child.type.displayName !== "SortableListItem") {
        console.error(
          "TypeError: sortable list got a child which is not a SortableListItem component."
        );
        return;
      }
      return child;
    })}
  </Sortable>
);

// interface BaseSortableListItemProps {
//   data: any;
//   getDataKey?: (d: any) => String;
//   getItemRender?: (d: any) => React.ReactElement;
//   onSelect?: (order: string) => void;
//   onDoubleClick?: (order: string) => void;
// }

export const SortableListItem = ({
  data,
  selectedKeys,
  multiple,
  selectable,
  draggable,
  getDataKey,
  getItemRender,
  onSelect,
  onDoubleClick,
  onDragStart
}) => {
  const key = typeof getDataKey === "function" ? getDataKey(data) : data;
  const checked = (selectedKeys || []).indexOf(key) !== -1;
  return (
    <div
      className={classnames("sortable-list-item-wrap", {
        "sortable-list-item-selected": checked
      })}
      draggable={draggable}
      data-id={key}
      onClick={
        selectable
          ? () => {
              let checkedKeys = [...selectedKeys];
              if (multiple) {
                const index = checkedKeys.indexOf(key);
                if (index !== -1) {
                  checkedKeys.splice(index, 1);
                } else {
                  checkedKeys.push(key);
                }
              } else {
                checkedKeys = [key];
              }
              if (typeof onSelect === "function") {
                onSelect(checkedKeys);
              }
            }
          : undefined
      }
      onDoubleClick={
        selectable
          ? () => {
              if (typeof onDoubleClick === "function") {
                onDoubleClick(key);
              }
            }
          : undefined
      }
      onDragStart={draggable ? onDragStart : undefined}
    >
      {typeof getItemRender === "function" ? getItemRender(data) : data}
      {checked && [
        <span className="wea-icon-selected-bg" />,
        <i className="icon-coms-Selected" />
      ]}
    </div>
  );
};

SortableListItem.displayName = "SortableListItem";
SortableListItem.defaultProps = {};



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/components/SortableList.js